module.exports = __webpack_public_path__ + "img/img37.13eecc01.png";